/**
 * Wochenrückblick auf dem Gerät: Zeilen sammeln, rechnen lässt `weekReview`.
 */

import { reviewSeries, weekReview } from '@kraftwerk/shared';
import type { ReviewInput, ReviewPoint, WeekReview } from '@kraftwerk/shared';
import { listBodyWeights } from './journal.js';
import { db } from './local.js';
import type { KraftwerkDatabase } from './local.js';
import { today } from './nutrition.js';
import { readProfile } from './profile.js';

async function reviewInput(now: Date, database: KraftwerkDatabase): Promise<ReviewInput> {
  const profile = await readProfile(database);
  return {
    today: today(profile.timezone, now),
    timeZone: profile.timezone,
    now,
    food: await database.food_log.toArray(),
    targets: profile.targets
      ? { kcal: profile.targets.kcal, protein: profile.targets.protein }
      : null,
    sessions: await database.workout_sessions.toArray(),
    sets: await database.workout_sets.toArray(),
    intakes: await database.supplement_intakes.toArray(),
    weights: await listBodyWeights(database),
  };
}

export async function loadWeekReview(
  now: Date = new Date(),
  database: KraftwerkDatabase = db,
): Promise<WeekReview> {
  return weekReview(await reviewInput(now, database));
}

/** Verlauf der letzten Wochen — dieselbe Rechnung, älteste Woche zuerst. */
export async function loadReviewSeries(
  weeks = 12,
  now: Date = new Date(),
  database: KraftwerkDatabase = db,
): Promise<ReviewPoint[]> {
  return reviewSeries(await reviewInput(now, database), weeks);
}
